import PageNotFound from '../Components/PageNotFound.js';

const FourOFour=()=>{
  return (
    <div>
      <PageNotFound/>
    </div>
  );
}
export default FourOFour;